import React, { useState, useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import UserContext from '../hooks/UserContext';
import styled, { css } from 'styled-components';
import Api from '../utils/Api';

const styles = css`
display: flex;
flex-direction: column;
margin: 0 auto;
.form {
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: left;
  & input {
    width: 100%;
  }
}
.controls {
  display: flex;
  align-self: end;
  margin-right: 30px;
}
.welcome {
  font-size: 2em;
  align-self: center;
  text-align: center;
}
.error-box {
  height: 2em;
  color: red;
}
`

const ChangePassword = styled(({ className }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [verifyPassword, setVerifyPassword] = useState('');
  const [passwordError, setPasswordError] = useState(true);
  const [submitOk, setSubmitOk] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const message = location?.state?.message || 'Change your password';
  const continueTo = location?.state?.continueTo || '/';
  const { user } = useContext(UserContext);

  const submit = async e => {
    e.preventDefault();

    if (newPassword !== verifyPassword) {
      toast.error('Verify password does not match');
      return;
    }

    const err = await Api.changePassword(currentPassword, newPassword);

    if (err) {
      toast.error(`Error changing password: ${Api.error(err)}`);
      return;
    }
    navigate('/login', { state: { message: 'Password changed successfully. Please login' } })
  }

  useEffect(() => {
    if (!user) navigate('/login', { state: { continueTo } });
  }, [user, navigate, continueTo]);

  useEffect(() => {
    if (newPassword !== verifyPassword) {
      setPasswordError('New password does not match');
      setSubmitOk(false);
    }
    else {
      setPasswordError(false);
      setSubmitOk(currentPassword !== '' && newPassword !== '');
    }
  }, [currentPassword, newPassword, verifyPassword]);

  return (
    <div className={className}>
      <div className='form'>
        <div className='welcome'>{`${message}`}</div>
        <input type='password' placeholder='Current password' value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} />
        <input type='password' placeholder='New password' value={newPassword} onChange={e => setNewPassword(e.target.value)} />
        <input type='password' placeholder='Verify password' value={verifyPassword} onChange={e => setVerifyPassword(e.target.value)} />
        <div className='error-box'>{passwordError}</div>
        <div className='controls'>
          <button className='primary' disabled={!submitOk} onClick={submit}>Change Password</button>
        </div>
      </div>
    </div>
  )
})`${styles}`;

export default ChangePassword;
